import React from "react";
import Navbar from "../../components/Navbar/index.tsx";
import Footer from "../../components/Footer/index.tsx";
import { FaTimesCircle } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="page">
      <Navbar />
      <div className="pt-24 container-site max-w-3xl text-center">
        <div className="flex flex-col items-center gap-4">
          <span className="text-rose-400">
            <FaTimesCircle size={64} />
          </span>
          <h1 className="heading-2">Payment Canceled</h1>
          <p className="subheading text-gray-300">
            Your checkout was canceled. You were not charged. You can retry any
            time.
          </p>
          <div className="mt-6 flex gap-3 justify-center">
            <button
              className="btn-primary"
              onClick={() => navigate("/pricing")}
            >
              Back to Pricing
            </button>
            <Link to="/" className="btn-secondary">
              Return Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentCancel;
